import { createElement } from 'react';
import { createBrowserRouter } from 'react-router';

import { setSessionExitNavigate } from '#/utils/auth/sessionExit';

import ErrorPage from './ErrorPage';
import { adminRoute } from './routes/adminRoutes';
import { publicRoutes } from './routes/publicRoutes';

const router = createBrowserRouter([
  ...publicRoutes,
  adminRoute,
  {
    path: '*',
    element: createElement(ErrorPage),
  },
]);

setSessionExitNavigate((to, options) => {
  router.navigate(to, options);
});

export default router;
